var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#FAEAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9965 24C17.8108 24.0009 17.6248 23.9249 17.4912 23.772L12.8312 18.4386C12.5889 18.1614 12.6173 17.7402 12.8945 17.498C13.1718 17.2557 13.5929 17.2841 13.8352 17.5614L17.3332 21.5647V12.6667C17.3332 12.2985 17.6317 12 17.9998 12C18.368 12 18.6665 12.2985 18.6665 12.6667V21.5533L22.1651 17.5606C22.4078 17.2837 22.8289 17.2559 23.1059 17.4986C23.3828 17.7412 23.4106 18.1624 23.1679 18.4394L18.5516 23.7077C18.4316 23.8841 18.2293 24 17.9998 24L17.9965 24Z",
    fill: "#D12F23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxdown);
export default __webpack_public_path__ + "static/media/boxdown.d2b861fa28acc64c703e8d762a481359.svg";
export { ForwardRef as ReactComponent };